export default {
    apiUri: process.env.VUE_APP_apiUrl,
    assetUrl: process.env.VUE_APP_assetUrl,
    pricing: 'gross',
    scrollToTop: true
}